<div class="v4-timeline-overflow">
    <div class="{{isToolTip ? 'tooltip-timeline' : 'container-fluid timeline-bg'}}">
        <span class="vertical-align-middle font-1_1rem bold-1-5 color-grey">{{ "Training timeline" | translator}}</span>
        <div class="session-list" *ngIf="sessions && sessions.length > 0; else noData">
            <div *ngFor="let session of sessions;let i = index"
                class="session-item d-flex justify-content-between align-items-center mb-2 v4-rel">
                <div [hidden]="i == sessions.length-1" class="v4-abs">
                    <div class="dot-box">
                        <div class="dot"></div>
                        <div class="line"></div>
                    </div>
                </div>
                <div class="session-info d-flex align-items-center color-grey">

                    <i *ngIf="session.sessionType === 'Online'" class="pi pi-globe mr-2"></i>
                    <i *ngIf="session.sessionType === 'Onsite'" class="pi pi-map-marker mr-2"></i>
                    <i *ngIf="session.sessionType === 'Video'" class="fa-solid fa-video mr-2"></i>
                    <i *ngIf="session.sessionType === 'Certificate'" class="pi pi-info-circle mr-2"></i>
                    <i *ngIf="session.sessionType === 'Survey'" class="fa-solid fa-chart-pie mr-2"></i>
                    <i *ngIf="session.sessionType === 'Assessment'" class="fa-solid fa-clipboard-user mr-2"></i>
                    <i *ngIf="session.sessionType === 'Material'" class="fa-regular fa-folder-open mr-2"></i>
                    <i *ngIf="session.sessionType === 'Material_Text'" class="fa-solid fa-book-open-reader mr-2"></i>

                    <span class="session-name">{{ session.title }}</span>
                </div>

                <div *ngIf="session.sessionType === 'Online' || session.sessionType === 'Onsite'" class="color-grey">
                    ({{session.start_time }} - {{session.end_time }})  {{session.date | date}}
                </div>

            </div>

        </div>
    </div>
</div>

<ng-template #noData>
    <app-no-data></app-no-data>
</ng-template>